import {ENDPOINT_FUNDING_OPPORTUNITY} from 'common/endpoints';
import {commonJwtHeader} from 'common/utils';

const callGetFundingOpportunityDraft = ({token, draftId}) => {
  return getFundingOpportunityDraft(token, draftId);
};

const getFundingOpportunityDraft = (token, draftId) => {
  return fetch(`${ENDPOINT_FUNDING_OPPORTUNITY}drafts/${draftId}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const updateFundingOpportunityDraft = ({draftId, payload, status}) => {
  return fetch(`${ENDPOINT_FUNDING_OPPORTUNITY}drafts/${draftId}`, {
    method: 'PUT',
    headers: commonJwtHeader(),
    body: JSON.stringify({payload, status}),
  });
};

/** Currently not used after migration */
const manageFundingOpportunity = ({programId, fundingOpportunityId}) => {
  return fetch(`${ENDPOINT_FUNDING_OPPORTUNITY}${fundingOpportunityId}/draft`, {
    method: 'POST',
    headers: commonJwtHeader(),
  });
};

export default {
  callGetFundingOpportunityDraft,
  getFundingOpportunityDraft,
  updateFundingOpportunityDraft,
  manageFundingOpportunity,
};
